'use strict';

module.exports = require('./Trigger');


//////////////////
// WEBPACK FOOTER
// ./~/._rc-trigger@1.10.3@rc-trigger/lib/index.js
// module id = 125
// module chunks = 0